import { parseFilename } from './files';
import axios from 'axios';
import { AMAZON_SALES_BASE_URL } from '../constants';

export { downloadBlob } from './files';

export interface AmazonSalesResult {
  blob: Blob;
  filename: string;
}

export async function calculateAmazonSales(
  settlementFile: File,
  outputFilename?: string
): Promise<AmazonSalesResult> {
  const formData = new FormData();
  formData.append('settlement_file', settlementFile);

  try {
    const response = await axios.post(
      `${AMAZON_SALES_BASE_URL}/amazon-sales/calculate`,
      formData,
      { responseType: 'blob' }
    );

    const blob = response.data as Blob;
    const filename = parseFilename(
      response.headers['content-disposition'] || null,
      outputFilename || 'Amazon_Sales_Update.xlsx'
    );

    return { blob, filename };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorBlob = error.response?.data as Blob | undefined;
      const contentType = String(error.response?.headers?.['content-type'] || '');
      const data =
        errorBlob && contentType.includes('application/json')
          ? JSON.parse(await errorBlob.text())
          : null;
      const message = (data && data.detail) || `Calculation failed with status ${error.response?.status}`;
      throw new Error(message);
    }
    throw error;
  }
}
